var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isTable)?_c('data-table',{attrs:{"headings":_vm.data.headings,"items":_vm.data.items}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }